import { render } from "./GalleryMin.vue?vue&type=template&id=0cb8afb4&scoped=true"
const script = {}

import "./GalleryMin.vue?vue&type=style&index=0&id=0cb8afb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb8afb4"]])

export default __exports__